import ApiClient from '@/ApiClient';
import { queryOptions } from '@tanstack/vue-query';

// `filters` is a ref/computed of { starts_on, ends_on } so the query refetches on date change.
export const getSalaryReport = filters =>
  queryOptions({
    queryKey: ['salary_report', filters],
    queryFn: async () => {
      const response = await ApiClient.getSalarySettlement(filters.value);
      return (response?.data ?? []).sort((a, b) => new Date(b.salary_completed_at) - new Date(a.salary_completed_at));
    },
  });
